import * as angular from "angular";

const allStatuses = [
  'Created',   // created waiting to the picker
  'Ready',     // (Packed) - packed and ready to pick up by the customer
  'InTransit', // The customer is on his way for pickup
  'Arrived',   // The customer has arrived for pickup
  'Canceled',  // Canceled by the customer/Admin
  'Completed' // Picked successfully by the customer
];

const activeStatuses = [
  'Created',   // created waiting to the picker
  'Ready',     // (Packed) - packed and ready to pick up by the customer
  'InTransit', // The customer is on his way for pickup
  'Arrived'   // The customer has arrived for pickup
];

const inActiveStatuses = [
  'Canceled',  // Canceled by the customer/Admin
  'Completed' // Picked successfully by the customer
];

const actions = {
  Edit: {
    title: 'Edit',
    action: 'Edit',
    icon: 'edit',
    permission: 'selfpickup.service.update'
  },
  AddPackaging: {
    title: 'Add Packaging',
    action: 'AddPackaging',
    icon: 'play-outline',
    permission: 'selfpickup.service.update'
  },
  sendMessage: {
    title: 'Send A Message',
    action: 'SendMessage',
    icon: 'message',
    permission: 'selfpickup.service.update'
  },
  Print: {
    title: 'Print Label',
    action: 'Print',
    icon: 'print',
    permission: 'selfpickup.service.update'
  },
  Cancel: {
    title: 'Cancel',
    action: 'Cancel',
    icon: 'trash',
    permission: 'selfpickup.service.delete'
  }
};

const selfPickupActionsByStatusMap = {
  Created: [
    actions.Edit,
    actions.AddPackaging,
    // actions.sendMessage,
    // actions.Print,
    actions.Cancel,
  ],
  Ready: [
    actions.Edit,
    actions.AddPackaging,
    // actions.sendMessage,
    // actions.Print,
    actions.Cancel,
  ],
  InTransit: [
    actions.Edit,
    actions.AddPackaging,
    // actions.sendMessage,
    // actions.Print,
    actions.Cancel,
  ],
  Arrived: [
    actions.Edit,
    // actions.AddPackaging,
    // actions.sendMessage,
    actions.Print,
    actions.Cancel,
  ],
  Completed: [
    // actions.Print
  ],
  Canceled: [
    // actions.Print
  ]
};

angular
  .module('bringoz.admin.self-pickups')
  .constant('selfPickupsConstants', {
    allStatuses: allStatuses,
    activeStatuses: activeStatuses,
    inActiveStatuses: inActiveStatuses,
    selfPickupActionsByStatusMap: selfPickupActionsByStatusMap
  });
